<script>
  import { onMount } from 'svelte'

  export let textSize

  let width
  let mounted = false
  let animeReady = false

  const getSize = () => {
    return textSize
  }

  let animElement
  let styleClassRnd = Math.random().toString(36).substring(7)

  function animeLoaded() {
    console.log('Loading anime')
    animeReady = true
    if (mounted) {
      wrap()
    }
  }

  onMount(async () => {
    console.log('mounted')
    mounted = true
    if (animeReady) {
      wrap()
    }
  })

  const wrap = () => {
    console.log('wrapping')

    animElement.style = `display: inline-block;line-height: 1em; font-size: ${textSize}; font-weight: 300`
    // Wrap every letter in a span
    console.log(animElement.innerHTML)
    animElement.innerHTML = animElement.textContent.replace(/\S/g, `<span class='letter${styleClassRnd}'>$&</span>`)

    anime.timeline({ loop: false }).add({
      targets: `.ml5${styleClassRnd} .letter${styleClassRnd}`,
      scale: [4, 1],
      opacity: [0, 1],
      translateZ: 0,
      easing: 'easeOutExpo',
      duration: 950,
      delay: (el, i) => 150 * i,
    })
  }
</script>

<svelte:head>
  <script src="anime.min.js" on:load={animeLoaded} defer>
  </script>
</svelte:head>

<div bind:clientWidth={width}>
  <h1 bind:this={animElement} style="font-size: {getSize()}" class="ml5{styleClassRnd}">
    <slot />
  </h1>
</div>

<style>
  h1 {
    margin: 0.2em;
  }
</style>
